import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { CHAIN_ID, NODE_URI } from ".";

export const injected = new InjectedConnector({ supportedChainIds: [CHAIN_ID] });

export const walletconnect = new WalletConnectConnector({
  rpc: { [CHAIN_ID]: NODE_URI },
  qrcode: true,
});
